import { useCallback } from "react";

import type { HotelTemplateSettingsResetInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { HotelTemplateSettingsResetMutation } from "./mutation";

export const useResetHotelTemplateSettings = () => {
	const { mutationFunc } = useCustomMutation(HotelTemplateSettingsResetMutation);

	const resetHotelTemplateSettings = useCallback(
		async (hotelTemplateSettings: HotelTemplateSettingsResetInput) => {
			return await mutationFunc({
				variables: {
					input: hotelTemplateSettings,
				},
			});
		},
		[mutationFunc],
	);

	return {
		resetHotelTemplateSettings,
	};
};
